import { createContext, useContext, useEffect, useState } from 'react';

type ThemeType = '' | 'xmas';

interface ThemeContextType {
  theme: ThemeType;
  setTheme: (value: ThemeType) => void;
}

const ThemeContext = createContext<ThemeContextType | undefined>(undefined);

export const ThemeProvider = ({ children }: { children: React.ReactNode }) => {
  const [theme, setTheme] = useState<ThemeType>(() => {
    // Lấy theme từ localStorage khi khởi động
    if (typeof window !== 'undefined') {
      return (localStorage.getItem('app_theme') as ThemeType) || '';
    }
    return '';
  });

  // Lưu vào localStorage khi theme thay đổi
  useEffect(() => {
    localStorage.setItem('app_theme', theme);
  }, [theme]);

  return <ThemeContext.Provider value={{ theme, setTheme }}>{children}</ThemeContext.Provider>;
};

// Hook dùng toàn app
export const useThemeStore = () => {
  const ctx = useContext(ThemeContext);
  if (!ctx) throw new Error('useThemeStore must be used inside <ThemeProvider>');
  return ctx;
};
